import { Outlet } from 'react-router-dom';
import { PageWithSidebar } from '@/components/layout/PageWithSidebar';
import { ShoppingCart, BarChart3, Shield } from 'lucide-react';

const productLinks = [
  { name: 'Order Management', href: '/products/ordermanage', icon: ShoppingCart },
  { name: 'Analytics', href: '/products/analytics', icon: BarChart3 },
  { name: 'Admin', href: '/products/admin', icon: Shield },
];

export function ProductsLayout() {
  return (
    <PageWithSidebar title="Products" sidebarLinks={productLinks}>
      <Outlet />
    </PageWithSidebar>
  );
}
